export default [

     {
          path: '/disaster-recovery-plan',
          name: 'DisasterRecoveryPlan',
          component: () => import("@/views/Page/DisasterRecoveryPlan/DisasterRecoveryPlan.vue"),
          meta: {
               title: 'Disaster Recovery Plan',
          },
     },
     {
          path: '/disaster-recovery-plan-details/:id',
          name: 'DisasterRecoveryPlanDetails',
          component: () => import("@/views/Page/DisasterRecoveryPlan/DisasterRecoveryPlanDetails.vue"),
          meta: {
               title: 'Disaster Recovery Plan Details',
          },
     }
];